import { render, staticRenderFns } from "./GlobalDevelopers.vue?vue&type=template&id=0a10bfc4&scoped=true&"
import script from "./GlobalDevelopers.vue?vue&type=script&lang=js&"
export * from "./GlobalDevelopers.vue?vue&type=script&lang=js&"
import style0 from "./GlobalDevelopers.vue?vue&type=style&index=0&id=0a10bfc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a10bfc4",
  null
  
)

export default component.exports